<template>
  <div class="is-border-top">
    <options-light-list :options="contactOptions"></options-light-list>
  </div>
</template>
<script>
import ContactMixin from '../ContactMixin'

export default {
  name: 'ContactOptions',
  components: {
    OptionsLightList: () => import('@/components/options/OptionsLightList')
  },
  mixins: [ContactMixin],
  watch: {
    sourceContactOptions (v) {
      this.updateSources({ options: v })
    }
  }
}
</script>
